import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const PublicFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLinkClick = (e, path) => {
    if (path.startsWith('#')) {
      e.preventDefault();
      const sectionId = path.replace('#', '');
      if (location.pathname === '/' || location.pathname === '/home') {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        navigate(`/${path}`);
      }
    }
  };

  const getLogoUrl = () => {
    const apiBase = import.meta.env.VITE_API_BASE_URL || '/my-lms/backend/api';
    return `${apiBase}/logo.php`;
  };

  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-grid">
            {/* Col 1: About Brand */}
            <div className="footer-col">
              <div className="footer-logo">
                <img src={getLogoUrl()} className="brand-logo" alt="PranaFlow Academy" />
                <span>PranaFlow</span>
              </div>
              <p className="footer-desc">
                Empowering global lives through authentic, classical yoga teacher training and education. Rooted in tradition, guided by rich experience.
              </p>
              <div className="footer-socials">
                <a href="https://www.facebook.com/people/PranaFlow-Academy/61591081966434/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                  <svg fill="#FFFFFF" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.75z"/></svg>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <svg fill="#FFFFFF" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
                </a>
                <a href="https://www.youtube.com/@PranaFlow_Academy" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
                  <svg fill="#FFFFFF" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23.498 6.163a3.003 3.003 0 0 0-2.11-2.11C19.525 3.545 12 3.545 12 3.545s-7.525 0-9.388.508a3.003 3.003 0 0 0-2.11 2.11C0 8.029 0 12 0 12s0 3.971.502 5.837a3.003 3.003 0 0 0 2.11 2.11c1.863.508 9.388.508 9.388.508s7.525 0 9.388-.508a3.003 3.003 0 0 0 2.11-2.11C24 15.971 24 12 24 12s0-3.971-.502-5.837zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                </a>
                <a href="https://wa.me/919548354084" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="WhatsApp">
                  <svg fill="#FFFFFF" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.731-1.456L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.859-4.407 9.862-9.823.002-2.623-1.017-5.09-2.871-6.944-1.853-1.854-4.321-2.87-6.944-2.872-5.442 0-9.863 4.41-9.865 9.827-.001 1.771.468 3.498 1.36 5.03l-.993 3.624 3.731-.977c-.105-.045-.2-.09-.285-.118zm10.741-7.234c-.29-.145-1.716-.848-1.982-.944-.266-.096-.46-.145-.653.145-.194.291-.75.944-.919 1.138-.169.194-.339.218-.629.073-.29-.145-1.226-.452-2.335-1.441-.864-.771-1.447-1.724-1.616-2.015-.17-.29-.018-.447.127-.591.131-.13.29-.339.436-.509.145-.17.194-.291.29-.485.097-.194.049-.364-.025-.509-.073-.145-.653-1.575-.895-2.156-.236-.569-.475-.491-.653-.5H6.99c-.194 0-.509.073-.775.364-.266.291-1.017.994-1.017 2.424s1.041 2.812 1.186 3.006c.145.194 2.049 3.129 4.965 4.385.694.299 1.236.478 1.658.613.697.221 1.332.19 1.833.115.559-.084 1.716-.703 1.958-1.382.242-.679.242-1.261.169-1.382-.072-.12-.266-.193-.556-.339z"/></svg>
                </a>
              </div>
            </div>

            {/* Col 2: Quick Links */}
            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><a href="#home" onClick={(e) => handleLinkClick(e, '#home')}>Home</a></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/courses">Courses</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
                <li><a href="#faq" onClick={(e) => handleLinkClick(e, '#faq')}>FAQ</a></li>
                <li><Link to="/teach-with-us">Teach With Us</Link></li>
              </ul>
            </div>

            {/* Col 3: Popular Courses */}
            <div className="footer-col">
              <h4>Popular Courses</h4>
              <ul className="footer-links">
                <li><Link to="/courses/200-hour-yoga-teacher-training-rishikesh">200 Hour Yoga TTC</Link></li>
                <li><Link to="/courses/300hr-yoga-ttc">300 Hour Yoga TTC</Link></li>
                <li><Link to="/courses/500hr-yoga-ttc">500 Hour Yoga TTC</Link></li>
                <li><Link to="/courses/diet-and-nutrition-course-online">Diet & Nutrition Course</Link></li>
                <li><Link to="/courses/face-yoga-teacher-training-course-online">Face Yoga Course</Link></li>
                <li><Link to="/courses/95-hour-kids-yoga-teacher-training">Kids Yoga TTC</Link></li>
              </ul>
            </div>

            {/* Col 4: Information */}
            <div className="footer-col">
              <h4>Information</h4>
              <ul className="footer-links">
                <li><a href="#home" onClick={(e) => handleLinkClick(e, '#home')}>Upcoming Batches</a></li>
                <li><Link to="/courses">Course Fees</Link></li>
                <li><a href="#home" onClick={(e) => handleLinkClick(e, '#home')}>Blog</a></li>
                <li><a href="#home" onClick={(e) => handleLinkClick(e, '#home')}>Gallery</a></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                <li><Link to="/data-deletion">Data Deletion</Link></li>
              </ul>
            </div>

            {/* Col 5: Contact Info */}
            <div className="footer-col">
              <h4>Contact Info</h4>
              <div className="footer-contact-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4.03C3.47 3 3 3.47 3 4.02 3 13.39 10.61 21 19.98 21c.54 0 .99-.45.99-1.02v-3.6c0-.55-.45-1-1-.99z"/>
                </svg>
                <a href="tel:09548354084" className="footer-contact-text" style={{ color: 'inherit', textDecoration: 'none' }}>09548354084</a>
              </div>
              <div className="footer-contact-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                <a href="mailto:pranaflowacademy@gmail.com" className="footer-contact-text" style={{ color: 'inherit', textDecoration: 'none' }}>pranaflowacademy@gmail.com</a>
              </div>
              <div className="footer-contact-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
                <span className="footer-contact-text">Rishikesh, Uttarakhand<br/>India - 249201</span>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026 PranaFlow Academy. All Rights Reserved.<br />PranaFlow Academy is operated by Rawtron Enterprises.</p>
          </div>
        </div>
      </footer>

      {/* Floating Action WhatsApp Button */}
      <a href="https://wa.me/919548354084" target="_blank" rel="noopener noreferrer" className="floating-whatsapp" aria-label="Chat on WhatsApp">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.731-1.456L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.859-4.407 9.862-9.823.002-2.623-1.017-5.09-2.871-6.944-1.853-1.854-4.321-2.87-6.944-2.872-5.442 0-9.863 4.41-9.865 9.827-.001 1.771.468 3.498 1.36 5.03l-.993 3.624 3.731-.977c-.105-.045-.2-.09-.285-.118zm10.741-7.234c-.29-.145-1.716-.848-1.982-.944-.266-.096-.46-.145-.653.145-.194.291-.75.944-.919 1.138-.169.194-.339.218-.629.073-.29-.145-1.226-.452-2.335-1.441-.864-.771-1.447-1.724-1.616-2.015-.17-.29-.018-.447.127-.591.131-.13.29-.339.436-.509.145-.17.194-.291.29-.485.097-.194.049-.364-.025-.509-.073-.145-.653-1.575-.895-2.156-.236-.569-.475-.491-.653-.5H6.99c-.194 0-.509.073-.775.364-.266.291-1.017.994-1.017 2.424s1.041 2.812 1.186 3.006c.145.194 2.049 3.129 4.965 4.385.694.299 1.236.478 1.658.613.697.221 1.332.19 1.833.115.559-.084 1.716-.703 1.958-1.382.242-.679.242-1.261.169-1.382-.072-.12-.266-.193-.556-.339z"/></svg>
      </a>
    </>
  );
};

export default PublicFooter;
